import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmDialog({ open, message, title, confirmLabel, denyLabel, onConfirm, onDeny}: {
    open: boolean,
    message: string,
    title: string,
    confirmLabel?: string,
    denyLabel?: string,
    onConfirm: (() => void) | undefined,
    onDeny: (() => void) | undefined
  }) {

  return (
    <>
      <Dialog
        open={open}
        onClose={onDeny}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onDeny}>{denyLabel ?? "No"}</Button>
          <Button onClick={onConfirm} autoFocus>
            {confirmLabel ?? "Yes"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}